import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'sortBy',
  pure: false,
  standalone: false,
})
export class SortByPipe implements PipeTransform {
  transform(value: any[], propertyName: string, nestedProperty?: string): any[] | null {
    if (!value) {
      return null;
    }

    const array = [...value];

    if (nestedProperty) {
      return array.sort((a, b) => {
        a = String(a[propertyName][nestedProperty]);
        b = String(b[propertyName][nestedProperty]);

        return a?.localeCompare(b, {numeric: true});
      });
    }

    return array.sort((a, b) => {
      a = String(a[propertyName]);
      b = String(b[propertyName]);

      return a?.localeCompare(b, {numeric: true});
    });
  }
}
